import { State } from '../types/todo-lists.types';

export const STATES = {
    TODO_LISTS_INIT: Symbol('TODO_LISTS_INIT'),
    TODO_LISTS_FETCHING: Symbol('TODO_LISTS_FETCHING'),
    TODO_LISTS_FETCHED: Symbol('TODO_LISTS_FETCHED'),
};

const state: State = {
    currentTodoList: null,
    todoLists: new Map(),
    todoListsState: STATES.TODO_LISTS_INIT,
    currentTodoListItems: [],
};

export default state;
